module.exports = __webpack_public_path__ + "img/swift-glx-plata-silice.c9390d05.png";